module.exports = __webpack_public_path__ + "img/product_8.17d023b.webp";